var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitterAddLitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_add_litter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_add"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.45,
    cy: 301.47,
    r: 297.94,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,242H352.14V157.36a55.8,55.8,0,0,0-55.64-55.65h0a55.81,55.81,0,0,0-55.64,55.65V242H161.24a55.8,55.8,0,0,0-55.64,55.64h0a55.81,55.81,0,0,0,55.64,55.64h79.62v84.69a55.81,55.81,0,0,0,55.64,55.64h0a55.8,55.8,0,0,0,55.64-55.64V353.23H441.8a55.81,55.81,0,0,0,55.64-55.64h0A55.8,55.8,0,0,0,441.8,242Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterAddLitter);
export default __webpack_public_path__ + "static/media/litter_add_litter.66022661afeb8923a5f345c793310f58.svg";
export { ForwardRef as ReactComponent };